import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { KENDO_MAP, TileUrlTemplateArgs } from '@progress/kendo-angular-map';
import { ApplicationApiService } from 'src/app/services/application-api.service';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatBadgeModule } from '@angular/material/badge';
import { LoadingComponent } from 'src/app/components/loading/loading.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [KENDO_MAP, CommonModule, MatListModule, MatCardModule, MatBadgeModule, LoadingComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  // Inject dependencies
  readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly applicationApiService = inject(ApplicationApiService);
  private readonly router = inject(Router);

  // Static configuration (no need for signals)
  readonly tileSubdomains = ["a", "b", "c"];
  readonly tileUrl = (e: TileUrlTemplateArgs): string => `https://${e.subdomain}.tile.openstreetmap.org/${e.zoom}/${e.x}/${e.y}.png`;

  // Signals for component state
  readonly region = signal<string>('');
  readonly showPopup = signal(false);
  readonly popupcardTitle = signal('Select a region');
  readonly popupcardSubtitle = signal('Hover to view details');
  readonly tracked = signal(0);
  readonly approved = signal(0);
  readonly unapproved = signal(0);
  readonly isLoading = signal(false);

  constructor() {
    this.loadGeoData();
  }

  private loadGeoData(): void {
    this.isLoading.set(true);
    this.applicationApiService.apiRegionsGeoJSON().subscribe((data: string) => {
      this.region.set(JSON.parse(data));
      this.isLoading.set(false);
    });
  }

  onRegionClick(e: any): void {
    this.router.navigate(['/region', e.shape.dataItem.properties.RegionId]);
  }

  onRegionHover(e: any): void {
    this.popupcardTitle.set(e.shape.dataItem.properties.RegionName);
    this.popupcardSubtitle.set("Approver: " + e.shape.dataItem.properties.Approver);
    this.tracked.set(e.shape.dataItem.properties.Tracked);
    this.approved.set(e.shape.dataItem.properties.Approved);
    this.unapproved.set(e.shape.dataItem.properties.Unapproved);
    this.showPopup.set(true);

    // Set hover color and border
    e.shape.options.set('fill.color', e.shape.dataItem.properties.HoverColor);
    e.shape.options.set('stroke.color', 'black');
  }

  onRegionUnhover(e: any): void {
    this.showPopup.set(false);

    // Remove hover color and border color
    e.shape.options.set('fill.color', e.shape.dataItem.properties.Color);
    e.shape.options.set('stroke.color', '#454141');
  }

  onShapeCreated(e: any): void {
    const shape = e.shape;
    const props = e.dataItem.properties;

    // Color
    shape.options.set('fill.color', props.Color);

    // Cursor
    e.shape.options.set('cursor', 'pointer');
  }
}
